import React, { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import { Card, Col, Row } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import { BASE_URL } from '../../../services/Api';
import { authHeader } from '../../../services/auth-header';
import PTOPRAMDConvert from '../AraiManufacturing/Convert';
import PTOPRPSIConvert from '../PumpSpareInternational/Convert';

function PurchaseToPurchaseReturnConvert() {
  const { id } = useParams();
  const [purchasetype, setPurchasetype] = useState('');
  const [purchasecategory, setPurchasecategory] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${BASE_URL}purchase/findById/${id}`, {
          headers: authHeader(),
        });
        setPurchasetype(response.data.purchasetype);
        setPurchasecategory(response.data.purchasecategory);
      } catch (err) {
        console.error('Error fetching data:', err);
        setError('Failed to load purchase data.');
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [id]);

  const renderPageDisplay = () => {
    if (purchasetype === 'Pump Spare' && purchasecategory === 'International') {
      return <PTOPRPSIConvert />;
    } else if (purchasetype === 'Manufacturing') {
      return <PTOPRAMDConvert />;
    }
    return null;
  };

  if (loading) return <div>Loading purchase data...</div>;
  if (error) return <div className="error-message">{error}</div>;

  return (
    <div className="Container">
      <Card className="card">
        <Card.Header className="card-header">
          <h6>CONVERT PURCHASE TO PURCHASE RETURN</h6>
          <div className="view-buttons">
            <Link to={`/pindex/1`}>
              <button className="button-70">BACK</button>
            </Link>
          </div>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md="6">
              <Form.Group>
                <Form.Label>Product Type:</Form.Label>
                <Form.Select disabled value={purchasetype}>
                  <option value="">--Please choose an option--</option>
                  <option value="Pump Spare">Pump Spare</option>
                  <option value="Manufacturing">Manufacturing</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md="6">
              <Form.Group>
                <Form.Label>PO Category:</Form.Label>
                <Form.Select disabled value={purchasecategory}>
                  <option value="">--Please choose an option--</option>
                  {/* Adjust categories as needed, e.g., if only International is relevant */}
                  <option value="International">International</option>
                  <option value="Domestic">Domestic</option>
                </Form.Select>
              </Form.Group>
            </Col>
            {renderPageDisplay()}
          </Row>
        </Card.Body>
      </Card>
    </div>
  );
}

export default PurchaseToPurchaseReturnConvert;
